<style scoped>
.expand-row .ivu-col {
	padding: 5px 0px;
}
</style>
<template>
	<div>
		
		<Row class="expand-row">
			
			<Col span="4">
			<span class="expand-key">{{  this.$t('EquipmentType') }}: </span>
			<span class="expand-value">{{ row.EquipmentType|EquipmentTypeDesc }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">{{  this.$t('ConnectorType') }}: </span>
			<span class="expand-value">{{ row.ConnectorType|ConnectorTypeDesc }}</span>
			</Col>

			<Col span="4">
			<span class="expand-key">{{  this.$t('StationMonitoring.MaxAlarmCode') }}: </span>
			<span class="expand-value">{{ row.MaxAlarmDesc }}</span>
			</Col>

			
			<Col span="4">
			<span class="expand-key">{{  this.$t('StationMonitoring.RatedPower') }}(KW): </span>
			<span class="expand-value">{{ row.RatedPower }}</span>
			</Col>

			
			<Col span="4">
			<span class="expand-key">{{  this.$t('StationMonitoring.BatteryTemp') }} (℃): </span>
			<span class="expand-value">{{ row.BatteryTemp }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">{{  this.$t('StationMonitoring.ConnectorTemp') }}(℃): </span>
			<span class="expand-value">{{ row.ConnectorTemp }}</span>
			</Col>
			
		</Row>
	</div>
</template>
<script>
	export default {
		props: {
			row: Object
		}
	};
</script>
